import React from 'react';
import './Header.css';

const Header = ({ finalPlanUrl, assetBaseUrl }) => {
  return (
    <>
      <div className="hOKUVn">
        <div className="cTxeDb">
          <div className="bbOsHr">
            <div className="bPvfCa">
              <a className="planLink" href={finalPlanUrl}>
                <img src={`${assetBaseUrl}/Header.jpg`} className="gQCKeh" alt="header" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hOKUVn">
        <div className="navbar">
          <nav>
            <ul>
              <li><a href={finalPlanUrl}>觀看全片 <span>Full Video</span></a></li>
              <li><a href={finalPlanUrl}>熱門男優 <span>Pornstars</span></a></li>
              <li><a href={finalPlanUrl}>暸解更多 <span>Learn More</span></a></li>
              <li><a href={finalPlanUrl} className="join-now">立即註冊 <span>Join Now</span></a></li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header; 